import window from 'window-or-global';
import { trigger } from '@confluence-classic/confluence-event_DO_NOT_USE';

let collectedMetrics = false;
let sessionName = '';
let activeSession = false;
let sessionTriggers = {};
let sessionEndingEvents = {};

const retrieveEvents = () => {
	const data = {};
	const analyticsObject = {
		name: sessionName,
		data,
	};
	const measurements = performance.getEntriesByType('measure');
	for (let i = 0; i < measurements.length; i++) {
		const measurement = measurements[i];
		const name = measurement.name;
		if (!sessionTriggers[name]) {
			continue;
		}

		data[`${name}.startTime`] = measurement.startTime;
		data[`${name}.duration`] = measurement.duration;
	}
	return analyticsObject;
};

const sendOffMetrics = () => {
	if (!collectedMetrics) {
		return;
	}

	const dataToSend = retrieveEvents();
	trigger('analytics', dataToSend);

	collectedMetrics = false;
};

export function register(name, triggers, endingEvents) {
	if (activeSession) {
		window.console.warn(
			'A session is already active, registering a new session will override the previous session',
		);
		return;
	}
	activeSession = true;

	sessionName = name;
	sessionTriggers = triggers;
	sessionEndingEvents = endingEvents;

	window.addEventListener('beforeunload', () => {
		if (collectedMetrics) {
			sendOffMetrics();
		}
	});
}

let performance = window.performance;

const getStartMarkName = (key) => {
	return `${key}.start`;
};

const getEndMarkName = (key) => {
	return `${key}.end`;
};

const beginPerformanceMetric = (key) => {
	if (!performance || !performance.mark || !sessionTriggers[key]) {
		return;
	}

	if (!collectedMetrics) {
		collectedMetrics = true;
	}

	const name = getStartMarkName(key);
	performance.mark(name);
};

const endPerformanceMetric = (key) => {
	if (!performance || !performance.mark || !sessionTriggers[key]) {
		return;
	}

	const start = getStartMarkName(key);

	if (performance.getEntriesByName(start, 'mark').length === 0) {
		window.console.warn(`Calling debugTimeEnd for ${key} before debugTime`);
		return;
	}

	const end = getEndMarkName(key);
	performance.mark(end);

	performance.measure(key, start, end);

	if (sessionEndingEvents[key]) {
		sendOffMetrics();
	}
};

export function debugTime(key) {
	beginPerformanceMetric(key);

	if (process.env.NODE_ENV !== 'production' && console.time) {
		console.log(`${key} started`);
		console.time(key);
	}
}

export function debugTimeEnd(key) {
	endPerformanceMetric(key);

	if (process.env.NODE_ENV !== 'production' && console.timeEnd) {
		console.timeEnd(key);
	}
}
